import { FC } from 'react';

import { CancellationReasonStep } from '@eneco/flows/components';

import { reasonMachine } from '../../machines/reasonMachine';

export const ReasonStep: FC = () => {
  return <CancellationReasonStep contentName="ToonCancelationReasonStep" reasonMachine={reasonMachine} />;
};
